import { BtnClickAnimation, color } from '../../../styles';
import { css } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface Props {
  id: number;
  name: string;
  unitName: string;
  roomName: string;
}

const ResidentCellContainer = css`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 6px;
  padding: 5px;
  min-width: 160px;
  width: 100%;
`;

const ResidentNameText = css`
  font-size: 14px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: left;
  word-break: break-all;
`;

const UnitNameText = css`
  display: flex;
  flex-direction: column;

  > span {
    font-size: 12px;
    font-weight: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-align: left;
    word-break: break-all;
  }
`;

const EditButtonsContainer = css`
  display: flex;
  column-gap: 11px;
`;

const StyledButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: 62px;
  height: 22px;
  border: 1px solid ${color.dark_gray};
  border-radius: 18px;
  color: ${color};
  font-weight: bold;
  background-color: ${color.white};
  padding: 0 8px;

  &:hover {
    opacity: 0.6;
    cursor: pointer;
  }

  ${BtnClickAnimation};
`;

const StyledButtonText = css`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 100%;
  font-size: 10px;
  font-weight: normal;
`;

const StyledButtonIcon = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  margin-right: 2px;
`;

export const ResidentRowHeader = ({ id, name, unitName, roomName }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div css={ResidentCellContainer}>
      <div css={ResidentNameText}>{name}</div>
      <div css={UnitNameText}>
        <span>{unitName}</span>
        <span>{roomName}</span>
      </div>
      <div css={EditButtonsContainer}>
        <div
          css={StyledButton}
          onClick={() => {
            history.push(`residents/${id}/care-record`);
          }}
        >
          <span css={StyledButtonText}>{t('detailOrEdit', '詳細 / 編集')}</span>
        </div>
        <div
          css={StyledButton}
          onClick={() => {
            history.push(`residents/${id}/edit`);
          }}
        >
          <img
            css={StyledButtonIcon}
            src='/images/icons/resident-setting.svg'
            alt={t('residentSetting', '入居者編集')}
          />
          <span css={StyledButtonText}>{t('edit', '編集')}</span>
        </div>
      </div>
    </div>
  );
};
